import AgentConfig from "../../../../src/components/AgentConfig";
import * as React from 'react';
export default {
  AgentConfig,
  React
};